var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoiseSuppressionOff = function SvgNoiseSuppressionOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5v22h2V5Zm12 0v22h2V5ZM5 11v10h2V11Zm12 0v10h2V11Zm8 0v10h2V11ZM1 14v4h2v-4Zm12 0v4h2v-4Zm16 0v4h2v-4Z"
  })));
};
export default SvgNoiseSuppressionOff;